import React, { useState } from 'react';
import ReactSelect from 'react-select'
import { SelectField } from '@payloadcms/plugin-form-builder/types';
import { Controller, Control, FieldValues, FieldErrorsImpl } from 'react-hook-form'
import { Error } from '../Error'
import { Width } from '../Width'

import classes from './index.module.scss'

export const Select: React.FC<
  SelectField & {
    control: Control<FieldValues, any>
    errors: Partial<
      FieldErrorsImpl<{
        [x: string]: any
      }>
    >
  }
> = ({ name, label, width, options, control, required, errors }) => {
  const [hasValue, setHasValue] = useState(false);
  return (
    <Width width={width ? width.toString() : undefined}>
      <div className={classes.select}>
        <Controller
          control={control}
          rules={{ required }}
          name={name}
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <ReactSelect
              instanceId={name}
              options={options}
              value={options.find(s => s.value === value)}
              onChange={val => {
                onChange(val.value);
                setHasValue(!!val.value);
              }}
              className={classes.reactSelect}
              classNamePrefix="rs"
              inputId={name}
            />
          )}
        />
        <label htmlFor={name} className={[classes.label, hasValue && classes.notEmpty].filter(Boolean).join(' ')}>
          {label}
        </label>
        {required && errors[name] && <Error />}
      </div>
    </Width>
  )
}
